import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { NationalizationProcessItemsBystudyCost } from "../NationalizationProcessItems/NationalizationProcessItemsBystudyCost";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const DDF001 = ({ configProcedure }: Props) => {

    const ddf = useDataBean(_NationalizationProcessGeneralInfo);

    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [idflujo, setIDflujo] = useState<number>(0);


    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            ddf.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        ddf.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
        else {
            ddf.setBean({
                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID()
            });
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(ddf.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: ddf.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(ddf.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        ddf.setBean({

            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            State: 1,

        });
        editaItem()
    }

    const createvdos = () => {
        ddf.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setTimeout(() => {
            editaItemvdos()
        }, 4000);
    }

    const editaItem = () => {


        ddf.instance.updateNationalizationProcessGeneralInfo(ddf.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })
    }


    const editaItemvdos = () => {

        console.log(ddf.bean);

        ddf.instance.updateNationalizationProcessGeneralInfo(ddf.bean).then(
            (resp: any) => {
                console.log(resp);
                onExportMap()
                toast.success('Actualizado');
                ddf.setBean(resp);
                // configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">

            <div className="col-md-12">

                <div className="row">
                    <div className="col-md-6">
                        <label>El proceso de nacionalizciaon es un descargue directo ?</label>
                        <select
                            className="form-control"
                            value={ddf.bean.DirectDownload}
                            onChange={(e: any) => {
                                ddf.setBean({
                                    ...ddf.bean,
                                    'DirectDownload': e.target.value
                                })
                            }}

                        >
                            <option value='false'>...</option>
                            <option value='true'>SI</option>
                        </select>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-6">
                        <BasicButton icon="ri-install-fill" clase="primary" eventClick={editaItemvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>

            </div>

        </div>
    )
}